import dayjs from 'dayjs'

export default () => dayjs('2021-01-01', 'YYYY-MM-DD')
